import React from 'react';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { AccountDetails } from '../AccountDetails';


export const Edit = ({ rowData, setDetailCallbackComponent }) => <Tooltip title="Szczegóły">
  <IconButton
    color="primary"
    onClick={() => {
      setDetailCallbackComponent(
        <AccountDetails />
      );
    }}
  >
    <EditIcon />
  </IconButton>
</Tooltip>;

Edit.propTypes = {
  detailCallbackComponent: PropTypes.func.isRequired
};
export default Edit;
